import { useEffect, useState } from 'react';

export const useApplication = (
  setValue: (
    name: string,
    value: any,
    config?: Partial<{
      shouldValidate: boolean;
      shouldDirty: boolean;
    }>
  ) => void
): { applicationId: string; data: Record<string, any> } => {
  const [applicationId, setApplicationId] = useState('');
  const [data, setData] = useState();

  useEffect(() => {
    const appId = localStorage.getItem('appId');
    const application = JSON.parse(localStorage.getItem('application'));

    setApplicationId(appId);

    if (application) {
      setData(application);
      Object.keys(application).forEach((key) => {
        setValue(key, application[key]);
      });
    }
  }, []);

  return { applicationId, data };
};
